"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.HELPFUL;
var options = ["Unhelpful for me", "Neutral / no effect for me", "Slightly helpful", "Moderately helpful", "Very helpful"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  options: options
};
var helpfulQuestions = [{
  prompt: "Thanks for taking the time to do that with me. I’d like to understand which exercises work best for you. How helpful was this exercise for you?",
  hideFromSummary: true,
  key: "helpful",
  type: "radio",
  batteryId: batteryId
}];
var questions = (0, _utils.wrapBattery)(helpfulQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  return answers;
}